// extracted by css-extract-rspack-plugin
export default {"colorIcon":"MZiyC","icon":"eK1lw c1h0N"};